<template>
  <contact-information-settings />
</template>

<script>
import ContactInformationSettings from "@/components/Ondemand/Settings/ContactInformation";
export default {
  components: {
    ContactInformationSettings,
  },
};
</script>

<style></style>
